export default {
  BADGES: "badges",
  CHAMPIONS: "champions",
};
